<script>
import Slick from "vue-slick";
import VueScrollTo from 'vue-scrollto';

export default {
  data() {
    return {
      slickOptions: {
        //options can be used from the plugin documentation
        slidesToShow: 1,
        infinite: false,
        accessibility: true,
        adaptiveHeight: window.innerWidth < 768 ? true : false,
        arrows: true,
        dots: true,
        draggable: false,
        edgeFriction: 0.3,
        swipe: true,
      }
    };
  },
  methods: {
    handleInit(event, slick) {
      slick.$dots.append('<li class="count-max">'+ slick.slideCount +'</li>');
      document.getElementById('scrollTrigger').click();
    },
  },
  components: {
    slick: Slick
  }
};
</script>

<template>
  <article id="article_cambiare" class="do-article">
    <a class="hidden" id="scrollTrigger" v-scroll-to="{ el: '#article_cambiare', duration: 1 }"></a>
    <div class="row no-gutters">
      <div class="col-xl-4 col-lg-5">
        <div class="do-article-info">
          <progressive-background src="static/images/article3.png"/>
          <h2>PAURA DI CAMBIARE?</h2>
          <p>
            Il tuo
            <strong>ruolo è fondamentale</strong> per poter usare al
            meglio un materiale tanto
            <strong>importante</strong> come la plastica.
          </p>
          <p>
            Ognuno di noi può
            <strong>regalarle</strong> una
            <strong>nuova vita</strong>. La scelta è anche tua!
          </p>
        </div>
      </div>
      <div class="col-xl-8 col-lg-7">
        <div class="do-article-content">
          <router-link class="do-back" to="/">
            <img src="static/images/back.svg" alt="Go Back">
          </router-link>

          <div class="do-article-slider">
            <slick ref="slick" :options="this.slickOptions" @init="handleInit">

              <!-- Slide -->
              <div class="do-slide">
                <div class="row mt-4">
                  <div class="col-12">
                    <p>Raggiungere il <strong>100%</strong> nella <strong>raccolta</strong> della plastica a fine vita è possibile solo grazie al <strong>concorso</strong> di <strong>tutti: istituzioni, cittadini e industria</strong>.</p>
                    <p>L’<strong>Italia</strong> si è dotata di un <strong>ottimo sistema</strong> per la <strong>raccolta differenziata</strong> dei rifiuti, frutto della <strong>cooperazione</strong> tra <strong>autorità centrali, locali</strong> e <strong>realtà produttive</strong>.</p>
                    <p>
                      Questo sistema ha ridotto a circa il <strong>15%</strong> la percentuale di imballaggi in plastica in Italia che <strong>non viene attualmente recuperata</strong> (dispersa o conferita in discarica).
                    </p>
                    <p>
                      L'industria delle materie plastiche supporta con convinzione la <strong>riduzione</strong> del <strong>ricorso alla discarica</strong>, privilegiando innanzitutto il <strong>riciclo meccanico</strong> e, quando non è possibile, l’utilizzo dei rifiuti in plastica come <strong>fonti energetiche alternative</strong>.
                      </p>
                    <p>Riciclare la plastica permette infatti di produrre altri oggetti ed <strong>innescare</strong> un <strong>circolo virtuoso</strong> di <strong>riuso</strong>. Cogli anche tu questa sfida ambiziosa ed affascinante.</p>
                    <p><strong>Non disperdere i rifiuti in plastica nell’ambiente</strong>. È necessario l’impegno di tutti per avviarli, tramite la raccolta differenziata, agli impianti di recupero. Pensando in grande si può davvero fare la differenza e ottimizzare l’intero ciclo di vita della plastica.</p>
                  </div>
                </div>
              </div>
              <!-- / Slide -->

              <!-- Slide -->
              <div class="do-slide">
                <div class="row mt-4">
                  <div class="col-xl-4 col-lg-12 col-md-4">
                    <h3>Il ciclo di vita della plastica</h3>
                    <p>
                      Alla fine del suo ciclo di vita, la plastica continua ad essere una <strong>risorsa utile</strong>. 
                    </p>
                    <p>
                      Può essere trasformata in materie prime per la produzione di nuovi prodotti o diventare energia.
                    </p>
                  </div>
                  <div class="col-xl-8 col-lg-12 col-md-8">
                    <img class="w-100 mb-4" src="static/images/PlasticEurope.gif" alt="" />
                    <!-- <video class="do-video" width="400" height="400" autoplay="true" muted loop>
                      <source src="static/images/PlasticEurope.mp4" type="video/mp4">
                      <source src="static/images/PlasticEurope.ogg" type="video/ogg">
                      Your browser does not support the video tag.
                    </video> -->
                  </div>
                </div>
              </div>
              <!-- / Slide -->

            </slick>
          </div>
          
        </div>
      </div>
    </div>
  </article>
</template>



// WEBPACK FOOTER //
// src/components/Cambiare.vue